function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "fire-gradient",
  x1: 0,
  x2: 0,
  y1: 0,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  className: "stop1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  className: "stop2"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M21.242 10.37a.49.49 0 01.336.32A9.11 9.11 0 0122 13.44c.055 5.24-4.275 9.553-9.73 9.694-5.457.14-10.022-3.944-10.26-9.178C2 13.785 2 13.613 2 13.44c-.004-2.84 1.308-5.536 3.58-7.356a.516.516 0 01.465-.092.49.49 0 01.335.324c.238.777.59 1.516 1.048 2.196a.255.255 0 00.235.108.25.25 0 00.208-.15A8.402 8.402 0 008.5 5.28 8.94 8.94 0 007.249.724.464.464 0 017.266.21a.509.509 0 01.492-.204c5.865 1.041 10.265 5.742 10.719 11.452.005.079.05.15.121.19.071.042.158.046.233.012a8.673 8.673 0 001.947-1.198.516.516 0 01.464-.093zM9.137 19.231A4.102 4.102 0 0012 20.4a4.01 4.01 0 002.852-1.102A3.688 3.688 0 0016 16.56c.11-1.441-.701-2.802-2.051-3.443a.261.261 0 00-.211 0 .239.239 0 00-.138.152 2.21 2.21 0 01-.735 1.013.258.258 0 01-.216.057.253.253 0 01-.177-.132 3.971 3.971 0 01.47-3.995.233.233 0 000-.29.257.257 0 00-.292-.08c-2.785 1.116-4.613 3.713-4.65 6.61a3.776 3.776 0 001.137 2.78z",
  clipRule: "evenodd"
});

var SvgFlame = function SvgFlame(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlame, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flame.ea35a0ef.svg";
export { ForwardRef as ReactComponent };